module.exports = __webpack_public_path__ + "img/obtawhicon2.a2bbdab8.png";